module.exports = __webpack_public_path__ + "images/landing/vehicle/carandbike-storage--motorcycle.jpg";